<!-- <template>
<div>
        <div class="question-card">
            <b-row>
                <b-col cols="12" lg="12">
                    <div v-if="step != 1" class="tile selected"  >
                        <h3 class="tile-title">{{ selectedCluster }}</h3>
                        <p class="tile-description">{{ selectedCluster && clusters.find(item => item.label ===selectedCluster ).description }}</p>
                        <span class="checkmark">✅</span>
                    </div>
                    <div v-if="step === 1" >
                        <h3 class="question-title text-center">Choose a Career Cluster Group</h3>
                        <div class="grid-container">
                            <div v-for="cluster in clusters" :key="cluster.label" class="tile" :class="{ selected: selectedCluster === cluster.label }" @click="selectCluster(cluster.label)">
                                <h3 class="tile-title">{{ cluster.label }}</h3>
                                <p class="tile-description">{{ cluster.description }}</p>
                                <span class="checkmark">✅</span>
                            </div>
                        </div>
                        </div>
                        <!-- <div v-if="step === 1" class="button-container">
                        <button class="continue-button" :class="{ active: selectedCluster }" @click="nextStep" :disabled="!selectedCluster">Continue</button>
                        </div> -->

                        <!-- Step 2: Interest Type (Multi-Select) -->
                        <!-- <div v-if="step === 2" class="question-container">
                        <h3 class="question-title">Which activities sound most exciting to you? (Pick 1–3)</h3>
                        <div v-for="activity in activities" :key="activity" class="option" :class="{ selected: userPreferences.activities.includes(activity) }" @click="toggleActivity(activity)">
                            {{ activity }}
                        </div>
                        <div class="button-container">
                            <button class="back-button" @click="previousStep">Back</button>
                            <button class="next-button" :class="{ active: userPreferences.activities.length > 0 }" @click="nextStep" :disabled="userPreferences.activities.length === 0">Next</button>
                        </div>
                        </div> -->

                        <!-- Step 3: Work Environment (Single-Select) -->
                        <!-- <div v-if="step === 3" class="question-container">
                        <h3 class="question-title">What kind of work environment do you prefer?</h3>
                        <div v-for="env in workEnvironments" :key="env" class="option" :class="{ selected: userPreferences.work_environment === env }" @click="selectWorkEnvironment(env)">
                            {{ env }}
                        </div>
                        <div class="button-container">
                            <button class="back-button" @click="previousStep">Back</button>
                            <button class="next-button" :class="{ active: userPreferences.work_environment }" @click="nextStep" :disabled="!userPreferences.work_environment">Next</button>
                        </div>
                        </div> -->

                        <!-- Step 4: Education Willingness (Single-Select) -->
                        <!-- <div v-if="step === 4" class="question-container">
                        <h3 class="question-title">How much time are you willing to spend in school after high school?</h3>
                        <div v-for="edu in educationOptions" :key="edu" class="option" :class="{ selected: userPreferences.education_willingness === edu }" @click="selectEducation(edu)">
                            {{ edu }}
                        </div>
                        <div class="button-container">
                            <button class="back-button" @click="previousStep">Back</button>
                            <button class="next-button" :class="{ active: userPreferences.education_willingness }" @click="nextStep" :disabled="!userPreferences.education_willingness">Next</button>
                        </div>
                        </div> -->

                        <!-- Step 5: Salary Goals (Multi-Select) -->
                        <!-- <div v-if="step === 5" class="question-container">
                        <h3 class="question-title">What is your starting salary goal after graduating? (Pick 1–3)</h3>
                        <div v-for="salary in salaryGoals" :key="salary" class="option" :class="{ selected: userPreferences.salary_goal.includes(salary) }" @click="toggleSalary(salary)">
                            {{ salary }}
                        </div>
                        <div class="button-container">
                            <button class="back-button" @click="previousStep">Back</button>
                            <button class="next-button" v-if="!loading" :class="{ active: userPreferences.salary_goal.length > 0 }" @click="fetchOccupations" :disabled="userPreferences.salary_goal.length === 0">Finish</button>
                            <button class="next-button" v-else :class="{ active: userPreferences.salary_goal.length > 0 }" :disabled="true">Loading <b-spinner small variant="light"></b-spinner></button>
                        </div>
                        </div> -->
                <!-- </b-col>
            </b-row>
        </div>
         <careerFitOccupations
          ref="childComp"
          :isOpen="careerFitOccupationsView"
          @chooseOccupationAI="chooseOccupationAI"
          @close="careerFitOccupationsView = false; closeModal()"
          :zip="zip"
          :age="age"
          :occupations="AIOccupations"
          :state="state"
          :city="city"
          @sort="sortByManual"
          :selectedZip="selectedZip"
    />
</div>

</template> --> 

<template>
  <div>
    <div class="question-card">
        <b-row>
            <b-col cols="12" lg="12">
                <div v-if="step != 1" class="tile selected">
                    <h3 class="tile-title">{{ selectedCluster }}</h3>
                    <p class="tile-description">{{ selectedCluster && clusters.find(item => item.label === selectedCluster).description }}</p>
                    <span class="checkmark">✅</span>
                </div>
                <div v-if="step === 1">
                    <h3 class="question-title text-center">Choose a Career Cluster Group</h3>
                    <div class="grid-container">
                        <div v-for="cluster in clusters" :key="cluster.label" 
                             class="tile" 
                             :class="{ selected: selectedCluster === cluster.label }" 
                             @click="selectCluster(cluster.label, cluster.description)">
                            <h3 class="tile-title">{{ cluster.label }}</h3>
                            <p class="tile-description">{{ cluster.description }}</p>
                            <span class="checkmark">✅</span>
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>
    </div>
      
    <careerFitOccupations
        ref="childComp"
        :isOpen="careerFitOccupationsView"
        @chooseOccupationAI="chooseOccupationAI"
        @close="careerFitOccupationsView = false; closeModal()"
        :zip="zip"
        :age="age"
        :occupations="AIOccupations"
        :state="state"
        :city="city"
        :selectedCluster="selectedCluster"
        @sort="sortByManual"
        :selectedZip="selectedZip"
        :selectedTitle="selectedTitle"
        :selectedDescription="selectedDescription"
    />
  </div>
  </template>

<script>

import careerFitOccupations from '@/CareerFitOccupations/careerFitOccupations.vue';
import occupationData from './occupation'

export default {
  name: "career-fit",
  components: {
    careerFitOccupations  
  },
  
    props: {
        isOpen: Boolean,
        state: String,
        city: String,
        zip: String,
        age: Array,
        selectedZip: String
    },
    watch:{
        prefer_working_people_default(newVal, oldVal) {
            this.current_step = 2;
        },   
        prefer_indoor_outdoor_default(newVal, oldVal) {
            this.current_step = 3;
        },
        prefer_problem_solving_default(newVal, oldVal) {
            this.current_step = 4;
        },
        how_much_schooling_default(newVal, oldVal) {
            this.current_step = 5;
        },
        job_flexibility_default(newVal, oldVal) {
            this.current_step = 6;
        },
        own_boss_default(newVal, oldVal) {
            this.current_step = 7;
        },
        motivates_you_default(newVal, oldVal) {
            this.current_step = 8;
        },
        physical_activity_default(newVal, oldVal) {
            this.current_step = 9;
        },
        technology_default(newVal, oldVal) {
            this.current_step = 10;
        },
        job_stability_default(newVal, oldVal) {
            this.submit();
        },
             
    },
    data() {
        return {
            showSurvey: false,
            step: 1,
            selectedCluster: null,
            selectedOccupation: null,
            careerFitOccupationsView: false,
            selectedTitle: '',
            selectedDescription: '',
            AIOccupations: [],
            loading: false,
            userPreferences: {
                activities: [],
                work_environment: '',
                education_willingness: '',
                salary_goal: []
            },
            occupations: [],
            errorMessage: '',
            clusters: [
                { label: "Advanced Manufacturing", description: "Making products with high-tech tools and machines." },
                { label: "Construction", description: "Building homes, buildings, and other structures." },
                { label: "Supply Chain & Transportation", description: "Moving goods and managing how they get from place to place." },
                { label: "Arts, Entertainment & Design", description: "Creating art, music, shows, and designs." },
                { label: "Hospitality, Events & Tourism", description: "Helping people have fun, travel, and enjoy events." },
                { label: "Financial Services", description: "Handling money, banking, and investments." },
                { label: "Education", description: "Teaching and helping people learn new things." },
                { label: "Healthcare & Human Services", description: "Caring for people's health and well-being." },
                { label: "Public Service & Safety", description: "Keeping communities safe and helping in emergencies." },
                { label: "Agriculture", description: "Growing food and taking care of land and animals." },
                { label: "Energy & Natural Resources", description: "Working with energy and natural resources." },
                { label: "Digital Technology", description: "Working with computers, apps, and technology." },
                { label: "Marketing & Sales", description: "Selling products and convincing people to buy them." },
                { label: "Management & Entrepreneurship", description: " Leading teams and starting your own business." },
            ],
            activities: [
                "Helping people", "Building or fixing things", "Solving puzzles and problems",
                "Working with computers", "Designing or creating", "Leading teams or projects",
                "Analyzing numbers or data", "Working outdoors", "Teaching others"
            ],
            workEnvironments: [
                "Indoors, office or lab", "Outdoors, hands-on", "Creative spaces (art, media, design)",
                "Healthcare or hospitals", "Schools or colleges", "Anywhere — I’m flexible!"
            ],
            educationOptions: [
                "0–2 years (certificates or associate’s degree)", "4 years (bachelor’s degree)",
                "6+ years (advanced degrees)"
            ],
            salaryGoals: [
                "$30,000–$45,000", "$45,000–$60,000", "$60,000–$75,000", "$75,000+"
            ],
            current_step:1,
            prefer_working_people:[{value:'1',text:'People (e.g., Teaching, Healthcare, Sales)'},{value:'2',text:'Data (e.g., Finance, Engineering, IT)'},{value:'3',text:'Things (e.g., Construction, Mechanics, Manufacturing)'}],
            prefer_working_people_default:null,
            prefer_indoor_outdoor:[{value:'1',text:'Indoor → Office-based jobs'},{value:'2',text:'Outdoor→ Fieldwork careers such as Construction, Agriculture, or Law Enforcement'}],
            prefer_problem_solving:[{value:'1',text:'Yes → (STEM, Finance, Business Analytics)'},{value:'2',text:'No → More hands-on roles like Trades, Healthcare, Arts, or Education'}],
            prefer_indoor_outdoor_default:null,
            prefer_problem_solving_default:null,
            how_much_schooling:[{value:'1',text:'High school or less'},{value:'2',text:'Some college or trade school'},{value:'3',text:'Bachelor\'s degree'},{value:'4',text:'Advanced degree (Master’s, PhD, Medical, Law)'}],
            how_much_schooling_default:null,
            job_flexibility:[{value:'1',text:'Structured → Working for an established organization with a regular work schedule'},{value:'2',text:'Flexible Hours → Self-employed, Creative, Medical, or Gig-based careers'}],
            job_flexibility_default:null,
            own_boss:[{value:'1',text:'Work for a company (Corporate, Government, Nonprofit)'},{value:'2',text:'Be my own boss (Entrepreneurship, Freelancing, Creative fields)'},{value:'3',text:'A mix (Consulting, Real Estate, Sales, or Business Owners)'}],
            own_boss_default:null,  
            motivates_you:[{value:'1',text:'Helping people and making an impact'},{value:'2',text:'Creativity and self-expression'},{value:'3',text:'Hands-on work and building things'},{value:'4',text:'High salary and financial security'}],
            motivates_you_default:null,
            physical_activity:[{value:'1',text:'Physical Activity → Skilled trades, Fitness, Emergency services'},{value:'2',text:'Mostly Seated → Office-based careers, Tech, Finance, Legal'}],
            physical_activity_default:null,
            technology:[{value:'1',text:'Yes → IT, Data Science, Engineering, Marketing'},{value:'2',text:'No → More hands-on roles like Trades, Healthcare, or Social Services'}],
            technology_default:null,
            job_stability:[{value:'1',text:'Very important (Healthcare, Government, Education, Finance)'},{value:'2',text:'Somewhat important (Tech, Creative, Business, Sales)'},{value:'3',text:'Not important, I like taking risks (Entrepreneurship, Entertainment, Gig economy)'}],
            job_stability_default:null,
            // careerFitOccupationsView: false,
            // AIOccupations: [],
            // loading:false
        };
    },
    methods: {
      selectCluster(clusterLabel, clusterDesc) {
            this.selectedCluster = clusterLabel;
            this.fetchOccupations(clusterLabel);

            this.selectedTitle = clusterLabel
            this.selectedDescription = clusterDesc
        },
        async fetchOccupations(cluster) {
            this.loading = true;
            this.errorMessage = null;
            try {
                const response = await fetch(`https://admin.spendid.io/api/serach-career-cluster-data?search=${cluster}`);
                const json = await response.json();
                
                // Normalize the data to ensure compatibility with the component
                this.AIOccupations = json.data.data.map(occupation => ({
                    occupation_name: occupation.occupation_name || occupation.occupation,
                    occupation_index: occupation.id,
                    starting_salary: occupation.starting_salary || 'N/A',
                    median_salary: occupation.median_salary || 'N/A',
                    degree_required: occupation.education_required || 'N/A',
                    job_security: occupation.job_security || 'N/A',
                    description: occupation.cluster_desc || 'No description available'
                }));

                this.selectedOccupation = null;
                this.careerFitOccupationsView = true;
                
                // Open modal after data is ready
                this.$nextTick(() => {
                    this.$refs.childComp.openModal();
                });
            } catch (err) {
                this.errorMessage = 'Failed to load occupation data.';
                console.error(err);
            } finally {
                this.loading = false;
            }
        },
        chooseOccupationAI(occupationIndex) {
            
            this.$emit('chooseOccupationAI', occupationIndex);
            // Add your logic for what happens when an occupation is chosen
        },
        sortByManual(type) {
            // Implement sorting logic if needed
            console.log('Sort by:', type);
        },
        closeModal() {
            // Add any additional close modal logic
            this.careerFitOccupationsView = false;
            this.$emit('close');
        }
    },
        toggleActivity(activity) {
          const index = this.userPreferences.activities.indexOf(activity);
          if (index === -1 && this.userPreferences.activities.length < 3) {
            this.userPreferences.activities.push(activity);
          } else if (index !== -1) {
            this.userPreferences.activities.splice(index, 1);
          }
        },
        selectWorkEnvironment(env) {
          this.userPreferences.work_environment = env;
        },
        selectEducation(edu) {
          this.userPreferences.education_willingness = edu;
        },
        toggleSalary(salary) {
          const index = this.userPreferences.salary_goal.indexOf(salary);
          if (index === -1 && this.userPreferences.salary_goal.length < 3) {
            this.userPreferences.salary_goal.push(salary);
          } else if (index !== -1) {
            this.userPreferences.salary_goal.splice(index, 1);
          }
        },
        nextStep() {
          if (this.step < 5) {
            this.step++;
          }
        },
        previousStep() {
          if (this.step > 1) {
            this.step--;
          } else {
            this.showSurvey = false; // Return to the button view
          }
        },
        async fetchMoreOccupations() {
          this.errorMessage = '';
          const payload = {
            selected_cluster: this.selectedCluster,
            user_preferences: this.userPreferences,
            exclude: this.occupations // Pass current occupations to exclude them
          };

          // Mock API response for additional 10 occupations
          const mockMoreResponse = {
            career_cluster: this.selectedCluster,
            occupations: [
              "DevOps Engineer", "Machine Learning Engineer", "Full Stack Developer", "IT Consultant",
              "Software Architect", "Data Engineer", "Security Analyst", "Product Manager",
              "UX Designer", "Technical Writer"
            ]
          };

          try {
            // Simulate API delay
            await new Promise(resolve => setTimeout(resolve, 1000));

            // Replace with actual API call in production
            /*
            const response = await fetch('https://api.x.ai/v1/grok', {
              method: 'POST',
              headers: {
                'Authorization': 'Bearer YOUR_XAI_API_KEY', // Replace with actual API key
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                system_prompt: "You are a friendly, encouraging career guide. Based on a selected Career Cluster and a few quick user preferences, suggest 10 more specific occupations from that Career Cluster that match their interests, excluding the previously provided occupations. Only suggest occupations from the approved OEWS database for that cluster. Keep suggestions realistic, aligned with their education and salary goals, and supportive in tone.",
                user_input: payload
              })
            });

            if (!response.ok) {
              throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const data = await response.json();
            const newOccupations = data.occupations || [];
            if (newOccupations.length === 0) {
              throw new Error("No additional occupations returned from the API.");
            }
            this.occupations = [...this.occupations, ...newOccupations];
            */

            this.occupations = [...this.occupations, ...mockMoreResponse.occupations];
          } catch (error) {
            this.errorMessage = `Failed to fetch more occupations: ${error.message}. Please try again.`;
          }
        },
        selectOccupation(occupation) {
          this.selectedOccupation = occupation;
          this.step = 8;
        },
        resetSurvey() {
          this.showSurvey = false;
          this.step = 1;
          this.selectedCluster = null;
          this.selectedOccupation = null;
          this.userPreferences = {
            activities: [],
            work_environment: '',
            education_willingness: '',
            salary_goal: []
          };
          this.occupations = [];
          this.errorMessage = '';
        },
        chooseOccupationAI(occupation_index){
            
            this.$emit('chooseOccupationAI', occupation_index);
            // this.$refs.childComp.closeModal();
        },
        sortByManual(){
            this.AIOccupations = this.AIOccupations.sort((a, b) => a.annual_salary - b.annual_salary);
            this.AIOccupations = this.AIOccupations.reverse();
        },
        closeModal() {
            this.$emit('close');
        },
        async submit(){
            this.loading = true;
            const occupation = occupationData.join(' | ')

            const prompt = `
            You are an AI Assistant. Given the following inputs:  
            The master list of Occupations "${occupation}" can be narrowed down for the User based on their response to these 5 questions. You should analyze the entirety of all answered questions to come up with a manageable set of Occupations that the user might be a fit for. Do not treat each question as a stand-alone prompt to return ALL occupations that fit each question separately. Use your deeper reasoning ability to interpret the entire set of answers to come up with your holistic recommended list of Occupations for the User to consider.

            **Input Questions:**  
            1-	Type of occupation?
            ${this.selectedCluster}

            2-	Which activities sound most exciting to you?
            ${this.userPreferences.activities.join(', ')}

            3-	What kind of work environment do you prefer?
            ${this.userPreferences.work_environment}

            4-	How much time are you willing to spend in school after high school?
            ${this.userPreferences.education_willingness}

            5-	What is your starting salary goal after graduating?
            ${this.userPreferences.salary_goal.join(', ')}

            **Output Format (Strictly Follow):**  
                [{
                    "occupation_index": <occupation_index>,
                    "degree_required": <predicted_degree_required>,
                    "job_security": <job_security>
                }]
 
            **Important(Strictly Follow):**  
            - Occupation index should be position of occupation as it appears in the master list of Occupations start from 0 and maximum is ${occupationData.length-1}.
            - The response must be a valid JSON object string with no additional text before or after.  
            - Do not include any explanations, notes, or markdown formatting (Strictly Follow).  
            - If any calculations are needed or any thought process or information that is sharable, do them silently and only return the final JSON (Strictly Follow). 
            - Example of valid output: [{"occupation_index": <occupation_index>,"degree_required": <predicted_degree_required>,"job_security": <job_security>}]
   
            
`           

            this.careerFitOccupationsView=false;
            const formData = new FormData();
            formData.append('task', 'plain');
            formData.append('text',  prompt);
            const result = await this.$http.post('https://editor.creativebuffer.com/get_response_2/', formData);
            try {    
                this.AIOccupations = JSON.parse(result.data.data);
                this.loading = false;
                this.$emit('occupations', this.AIOccupations);
                this.$refs.childComp.openModal();
                this.careerFitOccupationsView=true;
            } catch (error) {
                this.submit()
            }
        }

    }

</script>

<style scoped>
.grid-container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 1rem;
}

.tile {
    border: 2px solid #e0e0e0;
    border-radius: 10px;
    padding: 1rem;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
}

.tile:hover {
    border-color: #007bff;
    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

.tile.selected {
    border-color: #28a745;
    background-color: #f0f0f0;
}

.tile .checkmark {
    position: absolute;
    top: 10px;
    right: 10px;
    display: none;
}

.tile.selected .checkmark {
    display: block;
}
    .modal-tilte{
        font-size:18px;
        color:#303360;
        font-weight:500;
    }
    .question-steps{
        width:100%;
        /* background-color: #fbf9f9;
        border: solid 2px #eeeeee; */
        padding:30px;
        border-radius:20px;
        min-height: 362px;
        -webkit-animation: slide 0.5s forwards;
        -webkit-animation-delay: 2s;
        animation: slide 0.5s forwards;
        animation-delay: 2s;
        position: relative;
        background-color: rgb(255, 255, 255);
        box-shadow: rgba(71, 103, 136, 0.04) 0px 4px 5px 0px, rgba(71, 103, 136, 0.03) 0px 8px 15px 0px, rgba(71, 103, 136, 0.08) 0px 30px 50px 0px;
        border: 1px solid rgb(212, 224, 237);
    }
    @-webkit-keyframes slide {
        100% { left: 0; }
    }

    @keyframes slide {
        100% { left: 0; }
    }
    .question-step-tab-title{
        font-size:18px;
        color: #1f1f1f;
        font-weight:600;
    }
    .question-head h6{
        font-size:14px;
        color: #7b7b7b;
        font-weight:500;
    }
    .question-steps-slide .steps-continue{
        color: #009688;
    }
    /* .queston-list{
        width:100%;
        background-color:#fff;
        border:solid 1px #C2BBE9;
        padding:20px;
        border-radius:10px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
        -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
        -moz-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    } */
    .question-steps-card{
        margin-bottom:15px;
    }
    .question-steps-body{
        margin-top:15px;
    }
    .queston-btn{
        width:100%;
        background-color:#fff;
        border:solid 1px #AEB6BE;
        border-radius:10px;
        padding:10px;
        font-size:16px;
        font-weight:500;
        color:#494949;
        text-align:left;
    }
    .career-fit-occupations-header{
        padding:10px;
    }
    .queston-list .inputGroup {
        background-color: #ffffff;
        border: solid 1px #ced5ff;
        box-shadow: rgba(71, 103, 136, 0.04) 0px 4px 5px 0px, rgba(71, 103, 136, 0.03) 0px 8px 15px 0px, rgba(71, 103, 136, 0.08) 0px 30px 50px 0px;
        -webkit-box-shadow: rgba(71, 103, 136, 0.04) 0px 4px 5px 0px, rgba(71, 103, 136, 0.03) 0px 8px 15px 0px, rgba(71, 103, 136, 0.08) 0px 30px 50px 0px;
        -moz-box-shadow: rgba(71, 103, 136, 0.04) 0px 4px 5px 0px, rgba(71, 103, 136, 0.03) 0px 8px 15px 0px, rgba(71, 103, 136, 0.08) 0px 30px 50px 0px;
    }
    /* .career-fit-occupations-body{
        padding:20px;
    } */
    .parent-container {
      text-align: center;
      padding: 20px;
      width: 100%;
      max-width: 800px;
      margin: 0 auto;
    }
    .start-button {
      background-color: #662d91;
      color: #FFFFFF;
      font-size: 18px;
      font-weight: bold;
      padding: 12px 24px;
      border-radius: 8px;
      border: none;
      cursor: pointer;
    }
    .start-button:hover {
      background-color: #55247a;
    }
    .survey-container {
      background-color: #FFFFFF;
      width: 100%;
      max-width: 800px;
      margin: 0 auto;
      padding: 20px;
      box-sizing: border-box;
    }
    .grid-container {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 12px;
      width: 90%;
      margin: 0 auto;
      padding: 20px;
    }
    .question-card .tile {
      background-color: #FFFFFF;
      border: 1px solid #E0E0E0;
      border-radius: 12px;
      padding: 15px;
      display: block !important;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      cursor: pointer;
      position: relative;
      height: 120px;
      box-sizing: border-box;
    }
    .darkmode .question-card .tile {
      background-color: #292f45;
      border: solid 1px #555f79;
    }
    .darkmode .tile.selected, 
    .tile.selected {
      background-color: #2ba195 ;
      border: none;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    }
    .darkmode .tile:hover:not(.selected), 
    .tile:hover:not(.selected) {
      border-color: #2ba195 ;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    }
    .tile-title {
      font-size: 18px;
      font-weight: bold;
      color: #333333;
      margin: 0 0 8px 0;
      line-height: 1.2;
    }
    .darkmode .tile-title {
      color: #d0d2e8;
    }
    .tile.selected .tile-title {
      color: #FFFFFF;
    }
    .tile-description {
      font-size: 14px;
      color: #666666;
      margin: 0;
      line-height: 1.4;
    }
    .darkmode .tile-description {
      color: #dbdbdd;
    }
    .tile.selected .tile-description {
      color: #FFFFFF;
    }
    .darkmode .tile.selected .tile-description {
      color: #dbdbdd;
    }

    .checkmark {
      display: none;
      position: absolute;
      top: 10px;
      right: 10px;
      color: #FFFFFF;
      font-size: 20px;
    }
    .tile.selected .checkmark {
      display: block;
    }
    .question-container {
      width: 90%;
      margin: 0 auto;
      padding: 20px;
      text-align: center;
    }
    .question-title {
      font-size: 20px;
      font-weight: bold;
      color: #333333;
      margin-bottom: 20px;
    }
    .darkmode .question-title {
      color: #d0d2e8;
    }
    .option {
      display: block;
      background-color: #FFFFFF;
      border: 1px solid #E0E0E0;
      border-radius: 8px;
      padding: 15px;
      margin: 10px auto;
      width: 80%;
      max-width: 400px;
      cursor: pointer;
      font-size: 16px;
      color: #333333;
    }
    .darkmode .option {
      background-color: #292f45;
      border: solid 1px #555f79;
      color: #d0d2e8;
    }
    .option.selected {
      background-color: #2ba195 ;
      color: #FFFFFF;
      border: none;
    }
    .option:hover:not(.selected) {
      border-color: #2ba195 ;
    }
    .button-container {
      display: flex;
      justify-content: center;
      gap: 15px;
      margin-top: 20px;
    }
    .next-button, .continue-button, .more-button {
      background-color: #CCCCCC;
      color: #FFFFFF;
      font-size: 18px;
      font-weight: bold;
      padding: 12px 24px;
      border-radius: 8px;
      border: none;
      cursor: not-allowed;
    }
    .next-button.active, .continue-button.active, .more-button {
      background-color: #662d91;
      cursor: pointer;
    }
    .back-button {
      background-color: #FFFFFF;
      color: #666666;
      font-size: 18px;
      font-weight: bold;
      padding: 12px 24px;
      border-radius: 8px;
      border: 1px solid #E0E0E0;
      cursor: pointer;
    }
    .darkmode .back-button {
      background-color: #292f45;
      border: 1px solid #313131;
      color: #d0d2e8;
    }
    .back-button:hover {
      background-color: #F5F5F5;
    }
    .darkmode .back-button:hover {
      background-color: #000;
    }
    .results-container {
      width: 90%;
      margin: 0 auto;
      padding: 20px;
    }
    .result-item {
      background-color: #F5F5F5;
      border-radius: 8px;
      padding: 15px;
      margin: 10px 0;
      font-size: 16px;
      color: #333333;
      cursor: pointer;
    }
    .result-item.selected {
      background-color: #2ba195 ;
      color: #FFFFFF;
    }
    .more-button {
      display: block;
      margin: 20px auto;
    }
    .loading, .error-message, .completion-message {
      text-align: center;
      font-size: 18px;
      color: #666666;
      margin: 20px 0;
    }
    .error-message {
      color: #FF5555;
    }
    .completion-message {
      color: #2ba195 ;
      font-weight: bold;
    }
    @media (max-width: 768px) {
      .grid-container {
        grid-template-columns: 1fr;
      }
      .option {
        width: 100%;
      }
      .button-container {
        flex-direction: column;
        gap: 10px;
      }
      .next-button, .back-button, .continue-button, .more-button {
        width: 100%;
        max-width: 300px;
      }
    }
    @media (max-width: 560px) {
      .grid-container {
        padding: 0;
        width: 100%;
      }
     
    }
</style>